import { DatePipe } from '@angular/common';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { HostListener } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';

import { ToastrService } from 'ngx-toastr';
import { AddaccountComponent } from 'src/app/components/account/addaccount/addaccount.component';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { AddpartyComponent } from 'src/app/components/party/addparty/addparty.component';
import { ComponentCanDeactivate } from 'src/app/components/PendingChangesGuard';
import { AddproductComponent } from 'src/app/components/product/addproduct/addproduct.component';
import { AddrawmaterialComponent } from 'src/app/components/rawmaterial/addrawmaterial/addrawmaterial.component';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-addpayment',
  templateUrl: './addpayment.component.html',
  styleUrls: ['./addpayment.component.css']
})
export class AddpaymentComponent implements OnInit, ComponentCanDeactivate {

  @ViewChild('Selecter', { static: false }) ngselect: NgSelectComponent;

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ischeck: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  isproductaddmode: boolean = false;
  ispartyaddmode: boolean = false;

  rtnform: string = "";

  totalamount: number = 0;
  //Edit Get Values
  paymentmainColl: any = [];
  accountColl: any = [];
  paymentaccountColl: any = [];

  paymentmodeColl: any = [];
  partyColl: any = [];
  paymentBO: any = {}
  branchColl: any = [];


  costcenterColl: any = [];
  subledgerColl: any = [];

  partypayableColl: any = [];

  payableColl: any = [];

  partytypeColl: any = [];
  paymentdetailscoll: any = [];
  paymentaccountdetailscoll: any = [];


  ismanualclose: boolean;

  isaccountaddmode: boolean = false;

  errtxt: any = "";

  qtytotal: number = 0;
  unitpricetotal: number = 0;
  subtotal: number = 0;

  custmerrortxt: any = ""

  selectpayment: any = "PAYABLE"

  productColl: any;
  isLoadingResult: boolean;

  paymentform = new FormGroup({
    paymentid: new FormControl(0),
    paymentno: new FormControl('', Validators.required),
    paymentdate: new FormControl(null, Validators.required),
    partytype: new FormControl('', Validators.required),

    partyid: new FormControl(null, Validators.required),
    grandtotal: new FormControl(null),
    descr: new FormControl(''),
    refno: new FormControl(''),
    remarks: new FormControl(''),
    paymentmodeid: new FormControl(null, Validators.required),
    accountid: new FormControl(null, Validators.required),
    chequeno: new FormControl(''),
    chequedate: new FormControl(null),
    paymentdescr: new FormControl(''),
    costcenterid: new FormControl(null),
    isadvance: new FormControl(false),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Payment";

  gridfocusrow: number = -1;

  isshowpayable: boolean = false;

  @Input() paymentid: number = 0

  @Input() filterpaymentmodeid: number = 0;
  @Input() filteraccountid: number = 0;
  @Input() filterbranchid: number = null;
  @Input() filterfromdate: any = null;
  @Input() filtertodate: any = null;
  @Input() ptype: String = "";




  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private activeModal: NgbActiveModal, private route: ActivatedRoute,
    private productFindService: NgbModal, private confirmationDialogService: ConfirmationDialogService,
    public router: Router, private toastr: ToastrService, private loginService: LoginDataService, private datePipe: DatePipe) {


    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.paymentform.reset();
      this.fnInitializeForm();

      if (this.paymentid > 0) {
        this.fngetPayment();
      }
      else {
        this.fnSetFirstRowItem()
      }

      this.fngetPartytype()
      // this.fngetBranch()
      this.fngetPaymenttype()

      this.fngetParty()

      this.fngetCostCenter()

      this.fnGetAccount()


      this.fnSetInitialise()




    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit() {
    // this.loginService.fnSetFirstControlFocusLookup(this.ngselect);
  }

  fnSetInitialise() {

    // this.paymentform.controls["branchid"].setValue(Number(this.filterbranchid));
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.paymentid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isaccountaddmode = this.loginService.fnCheckUserRoleAction("Account", 'CREATE')
    this.ispartyaddmode = this.loginService.fnCheckUserRoleAction("Party", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeForm() {
    this.paymentform.setValue({
      paymentid: 0,
      paymentno: 'NEW',
      paymentdate: new Date(),
      partytype: 'S',
      partyid: null,
      grandtotal: null,
      descr: null,
      remarks: '',
      refno: '',
      paymentmodeid: null,
      accountid: null,
      chequeno: '',
      chequedate: null,
      paymentdescr: '',
      costcenterid: null,
      isadvance: false,
      inactive: false,
    })
  }
  fngetPaymenttype() {
    var data = {
      'paymentmodeid': 0,
      //'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getPaymentmodeTransaction(data)
      .subscribe(
        (res) => {
          console.log( res.json())
          this.paymentmodeColl = res.json().result;        
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetPartytype() {
    this.partytypeColl = [];
    this.partytypeColl.push({ value: 'C', displayname: 'Customer' }),
      this.partytypeColl.push({ value: 'S', displayname: 'Supplier' })
  }

  fngetParty() {

    var data = {
      'partyid': 0,
      'ptype': this.paymentform.get('partytype').value,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {

          this.partyColl = res.json().result;
          if (!this.paymentform.get('partytype').value) {
            this.partyColl = null;
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Get 
  fngetPayment() {

    var data = {
      'paymentid': this.paymentid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getPayment(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          console.log(result)
          this.paymentmainColl = result[0];

          var editdata = this.paymentmainColl[0];
          this.paymentBO = editdata;
          this.fnEditMode(editdata);
          var pColl = []
          pColl = result[1];

          this.paymentdetailscoll = []
          for (let abo of pColl) {
            if (abo.payableid > 0) {
              this.paymentdetailscoll.push(abo)
            }

          }
          this.paymentaccountdetailscoll = []
          for (let abo of pColl) {
            if (abo.accountid > 0) {
              this.paymentaccountdetailscoll.push(abo)
            }
          }

          if (this.paymentaccountdetailscoll.length === 0) {
            this.fnSetFirstRowItem()
          }


          if (this.paymentdetailscoll.length === 0) {
            if (this.paymentaccountdetailscoll.length > 0) {
              {
                this.selectpayment = 'ACCOUNT'
              }
            }
          }

          this.fnCalcDetails();

          this.fnGetPaymentPayable('HIDE')
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnValidation() {
    var _ischeck = false;
    var _detailscheck = false;
    this.custmerrortxt = ""

    //Entry
    for (let row of this.paymentdetailscoll) {
      if (row.payableid > 0) {
        _detailscheck = true;
      }
    }

    for (let row of this.paymentaccountdetailscoll) {
      if (row.accountid > 0) {
        _detailscheck = true;

      }
    }

    if (this.paymentform.get('isadvance').value) {
      _detailscheck = true;
    }


    if (!_detailscheck) {
      this.custmerrortxt = "Payments Details Cannot be empty"
      this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }

    //Amount Validation
    for (let row of this.paymentdetailscoll) {
      if (row.payableid > 0) {
        if (this.fnFormatData(row.paidamt) === 0) {
          this.custmerrortxt = "Paid amount is empty"
          this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
        else if (this.fnFormatData(row.balanceamt) < 0 && row.balanceamt > row.paidamt) {
          this.custmerrortxt = "Paid amount greater than invoice amount"
          this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
        else if (this.fnFormatData(row.balanceamt) > 0 && row.balanceamt < row.paidamt) {
          this.custmerrortxt = "Paid amount greater than invoice amount"
          this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }
    }

    for (let row of this.paymentaccountdetailscoll) {
      if (row.accountid > 0) {
        if (this.fnFormatData(row.paidamt) === 0) {
          this.custmerrortxt = "Paid amount cannot be empty"
          this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
          _ischeck = true;
        }
      }
    }

    if (this.paymentform.get('isadvance').value) {
      var grandtotal = this.paymentform.get('grandtotal').value
      if (this.fnFormatData(grandtotal) === 0) {
        this.custmerrortxt = "Paid amount cannot be empty"
        this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
        _ischeck = true;
      }
    }





    //Cheque Validation
    for (let row of this.paymentmodeColl) {
      if (row.paymentmodeid === this.paymentform.get("paymentmodeid").value) {

        if (row.paymenttype === 'BANK') {
          if (this.paymentform.get("chequeno").value === '') {
            this.custmerrortxt = "Cheque No cannot be empty"
            this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
            _ischeck = true;
          }
          else if (this.paymentform.get("chequedate").value === null || this.paymentform.get("chequedate").value === '') {
            this.custmerrortxt = "Cheque date cannot be empty"
            this.paymentform.controls['inactive'].setErrors({ 'notfound': true });
            _ischeck = true;
          }
        }

      }
    }

    return _ischeck;

  }

  fnResetValidation() {

    if (this.paymentform.get('inactive')) {
      this.paymentform.controls['inactive'].setErrors(null);
    }

  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()

      if (this.fnValidation()) {
        return false
      }

      //Validate
      if (this.paymentform.valid) {


        this.saveloading = true;

        var pColl = []

        for (let abo of this.paymentdetailscoll) {
          pColl.push(abo)
        }

        for (let abo of this.paymentaccountdetailscoll) {
          pColl.push(abo)
        }

        //Check
        var data = {
          'paymentid': this.paymentid,
          'paymentno': this.paymentform.get('paymentno').value,
          'paymentdate': this.fnFormatDatetime(this.paymentform.get('paymentdate').value),
          'partytype': this.paymentform.get('partytype').value,
          'partyid': this.paymentform.get('partyid').value,
          'grandtotal': this.paymentform.get('grandtotal').value,
          'descr': this.paymentform.get('descr').value,
          'remarks': this.paymentform.get('remarks').value,
          'refno': this.paymentform.get('refno').value,
          'paymentmodeid': this.paymentform.get('paymentmodeid').value,
          'accountid': this.paymentform.get('accountid').value,
          'chequeno': this.paymentform.get('chequeno').value,
          'chequedate': this.fnFormatDatetime(this.paymentform.get('chequedate').value),
          'paymentdescr': this.paymentform.get('paymentdescr').value,
          'costcenterid': this.paymentform.get('costcenterid').value,
          'isadvance': this.paymentform.get('isadvance').value,
          'inactive': this.paymentform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'paymentdetailscoll': pColl,
        }

        if (this.paymentform.get('paymentid').value > 0) {

          this.fnSetPayment(data);
        }
        else {

          this.fnInsertPayment(data);
        }

      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertPayment(data) {

    this.appService.fnInsertPayment(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status == 200) {
          //////this.toastr.success('', "The new Payment  has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.paymentno);

          var _result = res.json().result;
          if (_result.length > 0) {
            this.fnEditFormEdit(_result[0].paymentid);
          }

        } else {

          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPayment(data) {

    this.appService.fnSetPayment(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status == 200) {
          ////this.toastr.success('', "The Payment  has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.paymentid, data.paymentno);

          this.fnEditFormEdit(this.paymentid);
        } else {

          this.toastr.error('Error', res.json().err_message);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  private fnEditMode(deptBO) {

    deptBO.paymentdate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.paymentdate));
    deptBO.chequedate = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.chequedate));

    this.paymentform.setValue({

      paymentid: deptBO.paymentid,
      paymentno: deptBO.paymentno,
      paymentdate: deptBO.paymentdate,
      partytype: deptBO.partytype,
      partyid: deptBO.partyid,
      grandtotal: deptBO.grandtotal,
      descr: deptBO.descr,
      remarks: deptBO.remarks,
      refno: deptBO.refno,
      paymentmodeid: deptBO.paymentmodeid,
      accountid: deptBO.accountid,
      chequeno: deptBO.chequeno,
      chequedate: deptBO.chequedate,
      paymentdescr: deptBO.paymentdescr,
      costcenterid: deptBO.costcenterid,
      isadvance: deptBO.isadvance,
      inactive: deptBO.inactive,

    });

    this.fngetParty();

    this.fnGetPaymentAccount();
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
  }


  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }



  fnEditFormEdit(id) {

    this.paymentid = id;
    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;


    //this.ngOnInit();

    this.ismanualclose = true;
    this.fnCloseForm();

  }

  //Close
  async fnCloseForm() {

    try {

      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;


      this.emitData.emit("");
      this.activeModal.close(true);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnChangeResetParty() {

    this.paymentform.patchValue({ 'partyid': null });
  }


  @HostListener('window:beforeunload')
  canDeactivate(): any {

    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  //Details


  fnGetAccount() {
    this.isLoadingResult = true;

    var data = {
      'accountid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {
          this.accountColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnGetPaymentAccount() {
    this.isLoadingResult = true;

    var data = {
      'accountid': 0,
      'organizationid': this.loginService.fnGetOrganizationId(),
      'paymentmodeid': this.paymentform.get("paymentmodeid").value
    }
    this.appService.getAccountByPaymenttype(data)
      .subscribe(
        (res) => {
          this.paymentaccountColl = res.json().result;


          this.isLoadingResult = false;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetSubledger(abo) {
    var data = {
      'accountid': abo.accountid,
      'subledgerid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getSubledger(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.subledgerColl = result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetCostCenter() {
    var data = {
      'costcenterid': 0,
      'companyid': this.loginService.fnGetCompanyId()

    }
    this.appService.getCostCenter(data)
      .subscribe(
        (res) => {
          var result = res.json().result;

          this.costcenterColl = result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetPaymentPayable(type) {
    this.isLoadingResult = true;

    var data = {
      'partyid': this.paymentform.get('partyid').value,
      'trxdate': this.fnFormatDatetime(this.paymentform.get('paymentdate').value),
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.getPaymentPayable(data)
      .subscribe(
        (res) => {
          this.partypayableColl = res.json().result;

          this.isLoadingResult = false;

          if (this.partypayableColl.length > 0 && type === '') {
            this.fnOpenPayableSlider()
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnOpenPayableSlider() {
    this.payableColl = [];


    for (let pbo of this.partypayableColl) {
      if (this.paymentdetailscoll.length > 0) {

        const exitindex = this.paymentdetailscoll.findIndex(sku => sku.payableid === pbo.payableid);

        if (exitindex < 0) {
          this.payableColl.push(pbo);
        }

      }
      else {
        this.payableColl.push(pbo);
      }


    }


    this.isshowpayable = true;
  }

  fnApplyPayable() {
    for (let abo of this.payableColl) {
      if (abo.ischeck) {
        abo.paidamt = parseFloat(abo.balanceamt).toFixed(2);
        this.paymentdetailscoll.push(abo)
      }
    }
    this.isshowpayable = false;

    this.fnCalcDetails()
  }

  fnClosePayable() {
    this.isshowpayable = false;
  }

  fnCalcDetails() {
    this.totalamount = 0;
    if (this.paymentform.get('isadvance').value) {
      this.totalamount = this.paymentform.get('grandtotal').value
    }
    else {
      for (let row of this.paymentdetailscoll) {
        this.totalamount = Number(this.fnConvertDecimal(this.totalamount)) + Number(this.fnConvertDecimal(row.paidamt))
      }

      for (let row of this.paymentaccountdetailscoll) {
        this.totalamount = Number(this.fnConvertDecimal(this.totalamount)) + Number(this.fnConvertDecimal(row.paidamt))
      }

      this.paymentform.patchValue({ grandtotal: this.totalamount })

    }

    this.fnDiablePartyEntry()
  }


  fnChangeCheckApply(event, index) {
    if (event.target.checked) {
      this.paymentdetailscoll[index].paidamt = parseFloat(this.paymentdetailscoll[index].balanceamt).toFixed(2);
    } else {
      this.paymentdetailscoll[index].paidamt = 0
    }

    this.fnCalcDetails()

  }


  fnDeletePaymentConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.paymentdetailscoll.splice(index, 1)
            // if (this.paymentdetailscoll.length === 0) {
            //   this.fnSetFirstRowItem()
            // }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnDeletePaymentAccountConfirm(index) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete details?')
        .then((confirmed) => {
          if (confirmed) {
            this.paymentaccountdetailscoll.splice(index, 1)
            if (this.paymentaccountdetailscoll.length === 0) {
              this.fnSetFirstRowItem()
            }
            this.fnCalcDetails()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnChangeAccount(index) {

    for (let abo of this.accountColl) {

      if (this.paymentaccountdetailscoll[index].accountid === abo.accountid) {
        this.paymentaccountdetailscoll[index].accountname = abo.accountname;
      }
    }
    this.fnCalcDetails()

  }



  fnSetFirstRowItem() {
    if (this.paymentaccountdetailscoll.length > 0) {
      var aColl = this.paymentaccountdetailscoll.filter(x => !x.payableid)

      console.log(aColl)
      if (aColl.length > 0) {
        if (!aColl[aColl.length - 1].accountid) {
          return
        }
      }
      else {
        return
      }

    }

    var data = {
      paymentdetailsid: 0,
      paymentid: 0,
      accountid: null,
      accountname: '',
      discountamt: null,
      paidamt: null,
      refno: '',
      descr: '',
      costcenterid: null,
      subledgerid: null,
    }

    this.paymentaccountdetailscoll.push(data)

  }

  fnGetFirstRowItem() {

    var data = {
      paymentdetailsid: 0,
      paymentid: 0,
      accountid: null,
      accountname: '',
      discountamt: null,
      paidamt: null,
      refno: '',
      descr: '',
      costcenterid: null,
      subledgerid: null,
    }

    return data;

  }

  //Focus
  fnFocusChangeGridRow(index) {
    this.gridfocusrow = index
  }


  fnAccountFocusChangeGridRow(index) {
    this.gridfocusrow = index
  }

  fnFocusSubLedgerRow(index) {

    this.fngetSubledger(this.paymentaccountdetailscoll[index])

  }


  fnSetNextFocus(index) {

    if (this.paymentdetailscoll.length > 0) {

      if (this.paymentdetailscoll.length > index + 1) {
        this.gridfocusrow = index + 1
      }
    }


  }


  fnChangeCostCenter(index) {

    var _costcentername = "";



    for (let abo of this.costcenterColl) {
      if (this.paymentaccountdetailscoll[index].costcenterid === abo.costcenterid) {
        _costcentername = abo.costcentername;
      }
    }
    this.paymentaccountdetailscoll[index].costcentername = _costcentername;


    this.fnCalcDetails()

  }



  fnChangeSubLedger(index) {

    var _subledgername = "";



    for (let abo of this.subledgerColl) {
      if (this.paymentaccountdetailscoll[index].subledgerid === abo.subledgerid) {
        _subledgername = abo.subledgername;
      }
    }
    this.paymentaccountdetailscoll[index].subledgername = _subledgername;


    this.fnCalcDetails()

  }





  //AddParty
  private fnAddParty() {

    const modalRef = this.productFindService.open(AddpartyComponent, { size: <any>'l' });
    modalRef.componentInstance.ptype = this.ptype

    if (modalRef.componentInstance.ptype === 'C') {
      modalRef.componentInstance.formname = 'Customer'
    }
    else if (modalRef.componentInstance.ptype === 'S') {
      modalRef.componentInstance.formname = 'Supplier'
    }
    modalRef.componentInstance.ngOnInit();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetParty();

      if (receivedEntry > 0) {
        this.paymentform.patchValue({ partyid: receivedEntry })
      }
    });

  }
  //AddProduct
  private fnAddAccount(index) {

    const modalRef = this.productFindService.open(AddaccountComponent, { size: <any>'l' });
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnGetAccount();

      if (receivedEntry > 0) {
        this.paymentdetailscoll[index].accountid = receivedEntry

        this.fnChangeAccount(index)
      }
    });

  }


  fnChangePaymentTab(type) {
    this.selectpayment = type
  }


  fnDiablePartyEntry() {


    var _detailscheck = false;
    for (let row of this.paymentdetailscoll) {
      if (row.payableid > 0) {
        _detailscheck = true;
      }
    }

    if (_detailscheck === true) {
      this.paymentform.controls['partytype'].disable();
      this.paymentform.controls['partyid'].disable();
    }
    else {
      this.paymentform.controls['partytype'].enable();
      this.paymentform.controls['partyid'].enable();
    }



  }


  fnChangePartyType() {
    this.paymentform.patchValue({ 'partyid': null });
    this.fnClosePayable()
    this.fngetParty()
  }


  fnChangePaymentMode() {
    this.paymentform.patchValue({ 'accountid': null });

    this.fnGetPaymentAccount()
  }


  

  fnPostingConfirm(type) {
    this.confirmationDialogService.confirm('Confirm..', 'Do you  want to ' + type + ' Payment?')
      .then((confirmed) => {
        if (confirmed) {
          if (type === 'Post') {
            this.fnPosting()
          }
          else if (type === 'UnPost') {
            this.fnUnPosting()
          }

        }
      }
      );
  }


  fnPosting() {
    var data = {
      trxid: this.paymentid,
      doctype: 'PAYMENT',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertPostings(data)
      .subscribe(
        (res) => {
         
          if (res.json().status === 200) {
        
            this.fnEditFormEdit(this.paymentid);
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnUnPosting() {
    var data = {
      trxid: this.paymentid,
      doctype: 'PAYMENT',
      postingtype: 'MANUAL',
      modifiedby: this.loginService.fnGetModUserId()

    }
    this.appService.fnInsertUnPostings(data)
      .subscribe(
        (res) => {
          
          if (res.json().status === 200) {
          
            var result=res.json().result;
           
            if(result.length>0){
         
              if(result[0].checkresult==='DONE'){
                this.fnEditFormEdit(this.paymentid);
              }
              else{
                this.toastr.error('Error', result[0].checkresultmsg);
              }
            }
           
          }
          else {
            this.toastr.error('Error', res.json().err_message);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  
  fnEnableEditBtn() {
    if(this.paymentBO.iscancelled===1){
      return false;
    }
    else if (this.paymentBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }

  fnEnablePostBtn() {
    if(this.paymentBO.iscancelled===1){
      return false;
    }
    else  if (this.paymentBO.isposted === 1) {
      return false;
    }
    else {
      return true;
    }
  }


  
  fnEnableUnPostBtn() {
    if (this.paymentBO.isposted === 1) {
      return true;
    }
    else {
      return false;
    }
    
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnConvertDecimal(value) {
    if (!value) {
      return 0
    }
    else {
      return value
    }

  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnFormatData(data) {
    if (data === null || data === undefined) {
      return 0
    }
    else {
      return data
    }
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
